<div class="logos">
  <img src="/assets/icon/alchemist-logo.svg">
  <img class="pmi-logo" src="/assets/img/game/pmi-logo.svg">
</div>
<div class="middle-wrap">
  <div class="taerra"><img src="/assets/img/game/taerra.svg"></div>
  <div class="text-wrap">
    <div class="text">Welcome to this territory management simulation! Get ready to take on the fictional territory of Taerra, and practice your strategic thinking and planning skills.</div>
    <div class="text bold">Select Begin when you're ready to get started.</div>
  </div>
</div>
<app-button-bg class="btn" img="/assets/img/game/begin-bg.svg" (click)="onBeginClick()">
  <div class="btn-inside">Begin</div>
</app-button-bg>